import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'smatchy-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  standalone: false,
})
export class TitleComponent implements OnInit {
  @Input() mode: 'start' | 'end' = 'end';
  @Input() showLines = true;

  constructor() {}

  ngOnInit() {}
}
